module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="communitySwitch">\n    <div class="communitySwitch__spinner spinner spinner-small"></div>\n    <div class="communitySwitch__message">\n        Taking you to <b>'+
((__t=( community ))==null?'':_.escape(__t))+
' Community</b>\'s start page\n    </div>\n</div>\n';
}
return __p;
};
